import type { AllieLoadingConfig, RouteConfigLoading } from '@allie/app-ui-lib';
import { config } from './configs';

export const ROUTE_CONFIG_LOADING: RouteConfigLoading = {
  '/efficiency/shift/dashboard': { autoHide: false },
} as const;

export const CONFIG_LOADING: AllieLoadingConfig = {
  autoHideTime: config.ALLIE_LOADING_DEFAULT_AUTO_HIDE_TIME,
  autoHide: true,
  safetyTime: config.ALLIE_LOADING_DEFAULT_SAFETY_TIME,
} as const;
